// BUILD CROSS-SELL SLIDERS

const buildSwiperSlider = sliderElm => {
    const crossSellId = sliderElm.dataset.id;
    const crossSellTemplate = sliderElm.dataset.template;
    let slidePerViewTemplate = 2;
    if (crossSellTemplate === 'index') {
      slidePerViewTemplate = "auto";
    } else if (crossSellTemplate === 'product-tabs-cross-sell') {
      slidePerViewTemplate = 1.5;
    }
    return new Swiper(`#${sliderElm.id}`, {
        spaceBetween: 30,
        slidesPerView: slidePerViewTemplate,
        breakpoints: {
          600: {
            slidesPerView: 3,
            spaceBetween: 38
          },
          900: {
            slidesPerView: crossSellTemplate === 'index' ? 4.5 : 4,
            spaceBetween: 58
          }
        },
        navigation: {
            nextEl: `.swiper-button-next-${crossSellId}`,
            prevEl: `.swiper-button-prev-${crossSellId}`
        },
        pagination: {
            el: `.swiper-pagination-${crossSellId}`,
            type: 'progressbar',
        },
    });
}

const CrossSellSliders = document.querySelectorAll('.swiper.cross-sell-products');
CrossSellSliders && CrossSellSliders.forEach(slider => buildSwiperSlider(slider));